module.exports = __webpack_public_path__ + "static/media/1POLICY23.f282b380.jpg";